import Vue from "vue";
import Vuex from "vuex";
import { loginTeacherApi } from "../api/user";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    iphonex: false, // 是否为iphoneX以上机型
    wechat: false, // 是否为微信浏览器打开,
    hasNotch: false, // 是否安卓刘海屏
    headerTitle: "", // 标题：微信标题切换,
    hospitalizeId: "", // 住院号
    iphonexBottom: false, // 适配底部
    hospitalAuthList: [],
    vantPickeStyle: false, //是否给vant的picker加样式
    Android: false, // 安卓机
    token: localStorage.getItem("token"),
    miniprogram: false, //判断是否是小程序
    userInfo: {}, //用户数据
    roles: [], //权限,
    userPostCode: "",// 是班主任才返回的班主任岗位编号
    userId: localStorage.getItem("userId"),
    historyList: localStorage.getItem("historyList") ? JSON.parse(localStorage.getItem("historyList")) : [],
    isGradeHead: '' // 是否是年级长
  },
  mutations: {
    changeToken(state, val) {
      console.log("changeToken");
      state.token = val;
    },
    changeMiniprogram(state, val) {
      if (val) {
        state.miniprogram = true;
      } else {
        state.miniprogram = false;
      }
    },
    changeAndroid(state, val) {
      if (val) {
        state.Android = true;
      } else {
        state.Android = false;
      }
    },
    changeIphoneX(state, val) {
      if (val) {
        state.iphonex = true;
      } else {
        state.iphonex = false;
      }
    },
    changeHasNotch(state, val) {
      if (val) {
        state.hasNotch = true;
      } else {
        state.hasNotch = false;
      }
    },
    changeIphoneXBottom(state, val) {
      if (val) {
        state.iphonexBottom = true;
      } else {
        state.iphoneiphonexBottom = false;
      }
    },
    changeWeChat(state, val) {
      if (val) {
        state.wechat = true;
      } else {
        state.wechat = false;
      }
    },
    changeVantPickeStyle(state, val) {
      if (val) {
        state.vantPickeStyle = true;
      } else {
        state.vantPickeStyle = false;
      }
    },
    changeHeaderTitle(state, val) {
      if (val) {
        state.headerTitle = val;
      }
    },
    changeHospitalizeId(state, id) {
      state.hospitalizeId = id;
    },
    changeHospitalAuthList(state, list) {
      state.hospitalAuthList = list;
    },
    changeUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_HISTORYLIST: (state, historyList) => {
      state.historyList = historyList
    },
    SET_USERPOSTCODE: (state,userPostCode)=>{
      state.userPostCode = userPostCode
    },
    SET_ISGRADEHEAD: (state, isGradeHead) =>{
      state.isGradeHead = isGradeHead
    }
  },
  getters: {
    getHeaderTitle(state) {
      return state.headerTitle;
    },
    getHospitalizeCode(state) {
      return state.hospitalizeId;
    },
    getToken(state) {
      return state.token;
    },
    getInfo(state) {
      return state.userInfo;
    },
    getRoles(state) {
      return state.roles;
    },
    getHistoryList(state) {
      return state.historyList;
    },
    getUserPostCode(state) {
      return state.userPostCode
    },
    getIsGradeHead(state) {
      return state.isGradeHead
    }
  },

  actions: {
    login({ commit }, token) {
      return new Promise((resolve, reject) => {
        commit("changeToken", token);
        localStorage.setItem("token", token);
        loginTeacherApi({ token })
          .then(res => {
            console.log("--------11111111111", res);
            let { sysUser, permissions, userPostCode,isSchoolDoctor, isGradeHead } = res.content;
            console.log("----sysUser", sysUser);
            console.log("----permissions", permissions);
            let { id, userName, loginName, phonenumber, gradeId, deptId } = sysUser;
            let obj = {
              id,
              userName,
              loginName,
              phonenumber,
              gradeId,
              deptId
            };
            console.log("----obj", obj);
            const CRURList = [];
            if (permissions && permissions.length > 0) {
              const CRURList = permissions.map(item => item.href);
              localStorage.setItem("SET_ROLES", JSON.stringify(CRURList));
            }
            localStorage.setItem("isSchoolDoctor", isSchoolDoctor);
            commit("SET_USERPOSTCODE",userPostCode)
            commit("SET_ROLES", CRURList);
            commit("changeUserInfo", obj);
            commit("SET_ISGRADEHEAD", isGradeHead)
            resolve();
          })
          .catch(err => {
            reject(err);
          });
        // loginTeacherApi({ token })
        //   .then(res => {
        //     console.log("--------11111111111", res);
        //     let { sysUser, permissions } = res.content;
        //     console.log("----sysUser", sysUser);
        //     console.log("----permissions", permissions);
        //     let { id, userName, loginName, phonenumber, deptId } = sysUser;
        //     let obj = {
        //       id,
        //       userName,
        //       loginName,
        //       phonenumber,
        //       deptId
        //     };
        //     console.log("----obj", obj);
        //     const CRURList = [];
        //     if (permissions && permissions.length > 0) {
        //       const CRURList = permissions.map(item => item.href);
        //       localStorage.setItem("SET_ROLES", JSON.stringify(CRURList));
        //     }
        //
        //     commit("SET_ROLES", CRURList);
        //     commit("changeUserInfo", obj);
        //     resolve();
        //   })
        //   .catch(err => {
        //     reject(err);
        //   });
      });
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js